import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const DoorSize = ({ value, onChange, label = 'Door Slub Size:' }) => {
    const [selectedDoorSize, setSelectedDoorSize] = useState(value || "32");

    const handleDoorSizeChange = (e) => {
        setSelectedDoorSize(e.target.value);
        onChange(e.target.value);
    };

    // Trigger onChange when the component is initialized
     useEffect(() => {
        if (selectedDoorSize){
            //alert(selectedDoorSize);
            onChange(selectedDoorSize);
        }
    }, [onChange, selectedDoorSize]);

    return (
        <div className="a-container">
            <label htmlFor="DoorSize">{label}</label>
            <select
                id="DoorSize"
                value={selectedDoorSize}
                onChange={handleDoorSizeChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="24">{selectedDoorSize === "24" ? '24 " ✔' : '24 "'}</option>
                <option value="30">{selectedDoorSize === "30" ? '30 " ✔' : '30 "'}</option>
                <option value="32">{selectedDoorSize === "32" ? '32 " ✔' : '32 "'}</option>
                <option value="34">{selectedDoorSize === "34" ? '34 " ✔' : '34 "'}</option>
                <option value="36">{selectedDoorSize === "36" ? '36 " ✔' : '36 "'}</option>
                <option value="40">{selectedDoorSize === "40" ? '40 " ✔' : '40 "'}</option>
                <option value="42">{selectedDoorSize === "42" ? '42 " ✔' : '42 "'}</option>
            </select>
        </div>
    );
};

export default DoorSize;
